import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';

import funcionCambioURL from "../../../../funciones/gestionURL";
import { useNavigate, useLocation } from 'react-router-dom';

export default function SelectNumeroElementos({ perPage, convocatoria }) {
    console.log("perPage", perPage);
    const navigate = useNavigate();
    const location = useLocation();

    const conseguirRegistrosPorPagURL = () => {
        const params = new URLSearchParams(location.search);
        console.log("Prueba ", params.get('registrosPorPag'));
        return (params.get('registrosPorPag')) || perPage;
    };

    const [registrosPorPag, setRegistrosPorPag] = useState(conseguirRegistrosPorPagURL);

    const cambioURL = funcionCambioURL('registrosPorPag');

    const handleChange = (event) => {
        const numeroPagSeleccionada = event.target.value;
        setRegistrosPorPag(numeroPagSeleccionada);
        const nuevaURL = cambioURL(numeroPagSeleccionada);
        navigate(nuevaURL);
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "-34px" }}>
            <Button
                sx={{
                    color: convocatoria ? 'rgb(238, 128, 93)' : 'rgba(0, 60, 102, 0.8)',
                    minWidth: "auto",
                    padding: "5px 10px"
                }}
            >
                <b>Registros a mostrar</b>
            </Button>

            <Select
                displayEmpty
                id="demo-simple-select-autowidth"
                value={registrosPorPag}
                onChange={handleChange}
                autoWidth
                sx={{ width: 70, height: 30, fontSize: "14px" }}
                renderValue={(selected) => selected}
            >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
            </Select>
        </div>
    );
}
